import { call, put, select } from 'typed-redux-saga';

import { GRID_VIEW } from '../../../../../pages/call/constants';
import { setUserPreferredGridViewAction } from '../../../../../pages/call/features/goloom-video-grid';
import { getActiveGridView } from '../../../../../pages/call/selectors';
import { countMetrika } from '../../../../helpers/metrika';
import { showCommandList } from '../command-list/slice';

export function* dtmfOpenCommandListSaga() {
    countMetrika('dtmf', 'command-list', 'open');
    yield* put(showCommandList());
}

export function* dtmfCloseCommandListSaga() {
    yield* call(countMetrika, 'dtmf', 'command-list', 'close');
}

export function* dtmfToggleGridViewSaga() {
    const activeGridView = yield* select(getActiveGridView);

    if (activeGridView === GRID_VIEW.DEFAULT) {
        countMetrika('dtmf', 'command-list', 'set-grid-view', GRID_VIEW.PRESENTER);
        yield* put(setUserPreferredGridViewAction({ gridView: GRID_VIEW.PRESENTER }));
    } else {
        countMetrika('dtmf', 'command-list', 'set-grid-view', GRID_VIEW.DEFAULT);
        yield* put(setUserPreferredGridViewAction({ gridView: GRID_VIEW.DEFAULT }));
    }
}
